import React, { useState } from 'react';
import styles from "./ComplexFilter.module.css";
import InComponent from "../../subComponents/InInputComponent/InInputComponent";
import ReactSelect, { components as reactSelectComponents } from 'react-select';
import { toast } from 'react-toastify';
import { Chip, Typography,TextField, InputAdornment, Tooltip } from '@mui/material';
import { Add } from '@mui/icons-material';
import AdvancedFilterMenu from '../../AdvancedFilterMenu';
import { generateMenuMapping } from '../../../../helper/widget';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { symbol } from 'prop-types';
import BackendSearchSelect from '../BackendSearchSelect';
import FilterDateInput from '../FilterDateInput';
// import { useCatalogProductsData } from '../../../data/productAnalytics';

const MultiValueLabelWithTooltip = (props) => {
  const fullLabel = props?.data?.label ?? props?.children ?? "";
  return (
    <Tooltip
      title={String(fullLabel)}
      arrow
      placement="top"
      enterDelay={300}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 420,
            whiteSpace: "normal",
            wordBreak: "break-word",
            fontSize: "12px",
          },
        },
      }}
    >
      <span style={{ display: "inline-block", maxWidth: "100%" }}>
        <reactSelectComponents.MultiValueLabel {...props} />
      </span>
    </Tooltip>
  );
};

const StatusDotOption = (props) => {
  const status = String(props?.data?.status ?? "").toUpperCase();
  const showDot = Boolean(status);
  const isEnabled = status === "ENABLED";

  return (
    <reactSelectComponents.Option {...props}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        {showDot ? (
          <span
            title={status}
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              flexShrink: 0,
              backgroundColor: isEnabled ? "#12B76A" : "#98A2B3",
            }}
          />
        ) : null}
        <span style={{ minWidth: 0, wordBreak: "break-word" }}>
          {props.label}
        </span>
      </span>
    </reactSelectComponents.Option>
  );
};

const ComplexFilters = ({
    id,
    data,
    updateGroupConditionContent,
    removeGroupConditionContent,
    showCloseButton,
    operator,
    conditionError,
    config,
    type,
    userAction,
    multiple,
    inOperatorMaxValues,
    multipleLimit,
    preFilterOperators=[],
    showGroupCondition,
    groupConditionFunc,
    trackingSource
}) => {
    const [conditions, setConditions] = useState(Array.isArray(data) ? data : [{
        category: '',
        filter: '',
        userInput: '',
    }]);
    // const catalogData = useCatalogProductsData();
    // const {tabDataStructure} = catalogData
    // const headings = tabDataStructure[0]?.headings ?? []
    const headings = []

    const {mainItems,submenuItemsMap} = generateMenuMapping(config?.fields ?? [],headings)
  
    const addCondition = () => {
        if(multiple && conditions.length >= limit) { 
            toast.warning(`You can add maximum ${limit} conditions`);
            return;
        }
        const newCondition = {
            id: Date.now().toString(),
            category: '',
            filter: '',
            userInput: '',
        };
        const updatedConditions = [...conditions, newCondition];
        setConditions(updatedConditions);
        updateGroupConditionContent(updatedConditions, "data");
    };
    const limit = multipleLimit ? multipleLimit : 1000;

    const removeCondition = (index) => {
        const updatedConditions = [...conditions];
        updatedConditions.splice(index, 1);
        setConditions(updatedConditions);
        updateGroupConditionContent(updatedConditions, "data");
    };


    const handleConditionChange = (index, field, value) => {
        const updatedConditions = [...conditions];
        updatedConditions[index][field] = value;
        setConditions(updatedConditions);
        updateGroupConditionContent(updatedConditions, "data");
    };

    const validate = (inputValue, type) => {
        if (type === 'int' || type === 'facebookIntOperator') {
            if (inputValue === "") return true; // Allow blank values
            if (inputValue === "-") return true; // Allow only "-" for temporary input
            const numericRegex = /^-?[0-9]*\.?[0-9]*$/; // Allow "-", integers, and decimals
            return numericRegex.test(inputValue);
        } else if (type === 'string' || type === 'facebookStringOperatorMultiple' || type === 'customOnlyContins' || type === 'customOnlyContinsWithSelect' || type === 'stringSelect') {
            return true;
        } else if (type === 'date') {
            return true;
        } else {
            return false;
        }
    };

    return (
      <div
        className={`${styles.rulesContainer} ${
          type === "page" ? styles.page : ""
        }`}
      >
        <div className={multiple ? `${styles.cardContainer}` : undefined}>
          <div className={styles.cardContent} style={{ width: "100%" }}>
            <div style={{ width: "100%" }}>
              {conditions.map((condition, conditionIndex) => {
                const currCategory = config.fields.find(
                  (val) =>
                    val.name === condition.category ||
                    val.id === condition.category
                );

                const filterSelect = config.operators?.[currCategory?.datatype]
                  ? config.operators[currCategory.datatype].map((field) => ({
                      value: field.id,
                      label: field.name,
                      multiple: field.multiple,
                      dropdown: field.dropdown,
                      input: field.input,
                      source: "N/A",
                      symbol: field.symbol,
                    }))
                  : (config.operators?.["int"] ?? []).map((field) => ({
                      value: field.name,
                      label: field.name,
                      multiple: field.multiple,
                      dropdown: field.dropdown,
                      input: field.input,
                      source: "N/A",
                      symbol: field.symbol,
                    }));

                const isMultiple =
                  filterSelect.find((item) => item.label === condition.filter)
                    ?.multiple ?? false;
                const isDropdownEnabled =
                  filterSelect.find((item) => item.label === condition.filter)
                    ?.dropdown ?? false;
                const isInputEnabled =
                  filterSelect.find((item) => item.label === condition.filter)
                    ?.input ?? true;

                const optionObject = filterSelect
                  ? filterSelect.map((field) => ({
                      value: field.id,
                      label: field.name,
                    }))
                  : (config.operators?.["int"] ?? []).map((field) => ({
                      value: field.name,
                      label: field.name,
                    }));

                const placeholder = currCategory?.placeholder
                  ? currCategory?.placeholder
                  : "Enter value";
                const helpText = currCategory?.helpText
                  ? currCategory?.helpText
                  : null;
                const conditionErrors =
                  (conditionError.find((group) => group[condition.id]) || {})[
                    condition.id
                  ] || [];
                const currency = currCategory?.currency ?? null;

                let userInputOptions;
                if (
                  Array.isArray(condition.userInput) &&
                  condition.userInput.length > 0
                ) {
                  userInputOptions = condition.userInput.map((input) => ({
                    value: input,
                    label: input,
                  }));
                } else if (
                  condition.userInput &&
                  !Array.isArray(condition.userInput)
                ) {
                  userInputOptions = [
                    { value: condition.userInput, label: condition.userInput },
                  ];
                } else {
                  userInputOptions = [];
                }

                // ✅ Add symbol in selected filter value
                let filterValueSelected = [];
                if (condition.filter) {
                  const matchedFilter = filterSelect.find(
                    (item) => item.label === condition.filter
                  );
                  if (matchedFilter) {
                    filterValueSelected = [
                      {
                        value: matchedFilter.value,
                        label: (
                          <>
                            {matchedFilter.symbol ? (
                              <span
                                style={{
                                  fontSize: ".9rem",
                                  marginRight: ".5rem",
                                }}
                              >
                                {matchedFilter.symbol}
                              </span>
                            ) : null}
                            <span>{matchedFilter.label}</span>
                          </>
                        ),
                      },
                    ];
                  }
                }

                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        // gap: '8px',
                        padding: "4px",
                        width: "100%",
                      }}
                      key={condition.id}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <div style={{ display: "flex", width: "100%" }}>
                          {multiple && (
                            <>
                              {conditionIndex > 0 && limit > 2 ? (
                                <div
                                  className={`${styles.select} filterValueSelect`}
                                  style={{
                                    width: "70px",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <Chip
                                    label={operator}
                                    sx={{ fontSize: "12px" }}
                                    size="small"
                                    onClick={() => {
                                      userAction(true);
                                      let newOperator =
                                        operator?.toLowerCase() === "and"
                                          ? "OR"
                                          : "AND";
                                      updateGroupConditionContent(
                                        newOperator,
                                        "operator"
                                      );
                                    }}
                                  />
                                </div>
                              ) : conditionIndex > 0 ? (
                                <div
                                  className={`${styles.select} filterValueSelect`}
                                  style={{
                                    width: "70px",
                                    textAlign: "center",
                                    justifyContent: "flex-start",
                                  }}
                                ></div>
                              ) : (
                                <div
                                  className={`${styles.select} filterValueSelect`}
                                  style={{
                                    width: "70px",
                                    textAlign: "center",
                                    paddingLeft: "4px",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "12px",
                                      lineHeight: 1.715,
                                    }}
                                  >
                                    Where
                                  </Typography>
                                </div>
                              )}
                            </>
                          )}
                          <div
                            style={{
                              border:
                                !!conditionErrors.find(
                                  (error) => error.userInput
                                )?.userInput ||
                                (conditionErrors.some(
                                  (error) => error.filter
                                ) &&
                                  condition.filter === "")
                                  ? "1px solid red"
                                  : "1px solid #E0E0E0",
                            }}
                            className={styles.rowContentContainer}
                          >
                            <div
                              style={{
                                minWidth: "25%",
                                // maxWidth: "200px",
                                display: "flex",
                                alignItems: "center",
                                flex: 1,
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <AdvancedFilterMenu
                                  trackingSource={trackingSource}
                                  selectedOption={condition}
                                  triggerElement={
                                    <div
                                      style={{
                                        padding: "4px 8px",
                                        cursor: "pointer",
                                        width: "100%",
                                        flex: 1,
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                          lineHeight: 1.715,
                                          width: "100%",
                                          display: "inline-block",
                                          "& p": {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                            margin: 0,
                                          },
                                          "& .hoverIcon": {
                                            display: "none",
                                            fontSize: "20px",
                                            color: "#919191",
                                          },
                                          "&:hover .hoverIcon": {
                                            display: "inline-block",
                                          },
                                        }}
                                        variant="caption"
                                        component={"span"}
                                        title={condition?.category}
                                      >
                                        <p>
                                          <span
                                            style={{
                                              fontSize: "12px",
                                            }}
                                          >
                                            {condition.category
                                              ? condition.category.length > 20
                                                ? condition.category.slice(
                                                    0,
                                                    20
                                                  ) + "..."
                                                : condition.category
                                              : "Select Field"}
                                          </span>
                                          <KeyboardArrowDownIcon className="hoverIcon" />
                                        </p>
                                      </Typography>
                                    </div>
                                  }
                                  mainItems={mainItems}
                                  submenuItemsMap={submenuItemsMap}
                                  onSelect={(selectedOption) => {
                                    handleConditionChange(
                                      conditionIndex,
                                      "userInput",
                                      ""
                                    );
                                    handleConditionChange(
                                      conditionIndex,
                                      "filter",
                                      ""
                                    );
                                    handleConditionChange(
                                      conditionIndex,
                                      "category",
                                      selectedOption
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              style={{
                                minWidth: "20%",
                                maxWidth: "250px",
                                borderLeft: "1px solid rgb(224, 224, 224)",
                                display: "flex",
                                alignItems: "center",
                                flex: 1,
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <AdvancedFilterMenu
                                  trackingSource={trackingSource}
                                  triggerElement={
                                    <div
                                      style={{
                                        padding: "4px 8px",
                                        cursor: "pointer",
                                        flex: 1,
                                      }}
                                    >
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontSize: "12px",
                                          textWrap: "nowrap",
                                          lineHeight: 1.715,
                                          width: "100%",
                                          display: "inline-block",
                                          "& p": {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                            margin: 0,
                                          },
                                          "& .hoverIcon": {
                                            display: "none",
                                            fontSize: "20px",
                                            color: "#919191",
                                          },
                                          "&:hover .hoverIcon": {
                                            display: "inline-block",
                                          },
                                        }}
                                      >
                                        <p
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            margin: 0,
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            {filterValueSelected?.length ? (
                                              <>
                                                {filterValueSelected[0]
                                                  ?.symbol && (
                                                  <span
                                                    style={{
                                                      fontSize: ".9rem",
                                                      marginRight: ".8rem",
                                                    }}
                                                  >
                                                    {
                                                      filterValueSelected[0]
                                                        .symbol
                                                    }
                                                  </span>
                                                )}
                                                <span>
                                                  {filterValueSelected[0]?.label
                                                    ?.length > 26
                                                    ? filterValueSelected[0]?.label?.slice(
                                                        0,
                                                        26
                                                      ) + "..."
                                                    : filterValueSelected[0]
                                                        ?.label}
                                                </span>
                                              </>
                                            ) : (
                                              "Select Operator"
                                            )}
                                          </span>
                                          <KeyboardArrowDownIcon className="hoverIcon" />
                                        </p>
                                      </Typography>
                                    </div>
                                  }
                                  mainItems={filterSelect}
                                  submenuItemsMap={submenuItemsMap}
                                  onSelect={(selectedOption) => {
                                    // Preserve user input if the old/new operators accept the same input type.
                                    // Otherwise reset it to avoid incompatible values.
                                    const oldOperator = filterSelect?.find(
                                      (item) =>
                                        item?.label === condition?.filter
                                    );
                                    const newOperator = filterSelect?.find(
                                      (item) =>
                                        item?.label === selectedOption
                                    );

                                    const shouldPreserveUserInput =
                                      Boolean(oldOperator?.input) &&
                                      Boolean(newOperator?.input) &&
                                      (oldOperator?.multiple ?? false) ===
                                        (newOperator?.multiple ?? false);

                                    if (!shouldPreserveUserInput) {
                                      handleConditionChange(
                                        conditionIndex,
                                        "userInput",
                                        ""
                                      );
                                    }
                                    handleConditionChange(
                                      conditionIndex,
                                      "filter",
                                      selectedOption
                                    );
                                    userAction(true);
                                  }}
                                />
                              </div>
                            </div>
                            {!isInputEnabled ? (
                              <div
                                style={{
                                  width: "40%",
                                  background: "#FAFAFA",
                                }}
                              ></div>
                            ) : (
                              <div
                                style={{
                                  width: "40%",
                                  borderLeft: "1px solid rgb(224, 224, 224)",
                                  minWidth: 0,
                                  maxWidth: "40%",
                                }}
                              >
                                {(currCategory?.backendSearch === true ||
                                  currCategory?.optionData?.length > 0) &&
                                isDropdownEnabled ? (
                                  (() => {
                                    const selectComponents = {
                                      DropdownIndicator: () => null,
                                      IndicatorSeparator: () => null,
                                      MultiValueLabel: MultiValueLabelWithTooltip,
                                      Option: StatusDotOption,
                                    };
                                    const selectStyles = {
                                      container: (provided) => ({
                                        ...provided,
                                        width: "100%",
                                        maxWidth: "100%",
                                      }),
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: "32px",
                                        height: "auto",
                                        paddingRight: "8px",
                                        border: "none",
                                        borderTopRightRadius: "8px",
                                        borderBottomRightRadius: "8px",
                                        borderColor:
                                          conditionErrors.some(
                                            (error) => error.userInput
                                          ) && condition.userInput === ""
                                            ? "#FF4D4F"
                                            : "transparent",
                                        boxShadow: "none",
                                        outline: "none",
                                        fontSize: "12px",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        "&:hover": {
                                          borderColor:
                                            conditionErrors.some(
                                              (error) => error.userInput
                                            ) && condition.userInput === ""
                                              ? "#FF4D4F"
                                              : "transparent",
                                          boxShadow: "none",
                                        },
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        flexWrap: "wrap",
                                        flex: "1 1 0%",
                                        overflow: "hidden",
                                        maxWidth: "100%",
                                        minWidth: 0,
                                        padding: "2px 8px",
                                      }),
                                      input: (provided) => ({
                                        ...provided,
                                        margin: 0,
                                        padding: 0,
                                        fontSize: "12px",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        outline: "none",
                                        boxShadow: "none",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        fontSize: "12px",
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        fontSize: "12px",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }),
                                      multiValue: (provided) => ({
                                        ...provided,
                                        maxWidth: "100%",
                                        fontSize: "12px",
                                      }),
                                      multiValueLabel: (provided) => ({
                                        ...provided,
                                        fontSize: "12px",
                                        maxWidth: "140px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }),
                                      option: (provided) => ({
                                        ...provided,
                                        fontSize: "12px",
                                        lineHeight: "1.4",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        overflowWrap: "anywhere",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: "180px",
                                        overflow: "hidden",
                                        zIndex: 9999,
                                        fontSize: "12px",
                                      }),
                                      menuList: (provided) => ({
                                        ...provided,
                                        maxHeight: "150px",
                                      }),
                                      menuPortal: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                      }),
                                      noOptionsMessage: (provided) => ({
                                        ...provided,
                                        fontSize: "12px",
                                      }),
                                      loadingMessage: (provided) => ({
                                        ...provided,
                                        fontSize: "12px",
                                      }),
                                    };
                                    const handleSelectChange = (selectedOption) => {
                                      if (isMultiple) {
                                        const values = (selectedOption || []).map(
                                          (option) => {
                                            return Array.isArray(option.value)
                                              ? option.value[0]
                                              : option.value;
                                          }
                                        );
                                        handleConditionChange(
                                          conditionIndex,
                                          "userInput",
                                          values
                                        );
                                      } else {
                                        handleConditionChange(
                                          conditionIndex,
                                          "userInput",
                                          selectedOption
                                            ? [selectedOption.value]
                                            : []
                                        );
                                      }
                                      userAction(true);
                                    };

                                    if (currCategory?.backendSearch === true) {
                                      return (
                                        <BackendSearchSelect
                                          field={currCategory}
                                          isMulti={isMultiple}
                                          value={userInputOptions}
                                          components={selectComponents}
                                          placeholder="Select..."
                                          menuPlacement={multiple ? "bottom" : "top"}
                                          onChange={handleSelectChange}
                                          styles={selectStyles}
                                        />
                                      );
                                    }

                                    return (
                                      <ReactSelect
                                        isMulti={isMultiple}
                                        className="basic-single"
                                        classNamePrefix="Select Operator"
                                        defaultValue={userInputOptions}
                                        isSearchable={true}
                                        components={selectComponents}
                                        name="userInput"
                                        options={currCategory.optionData}
                                        key={JSON.stringify(userInputOptions)}
                                        placeholder={"Select..."}
                                        menuPlacement={multiple ? "bottom" : "top"}
                                        menuPortalTarget={
                                          typeof document !== "undefined"
                                            ? document.body
                                            : null
                                        }
                                        menuPosition="fixed"
                                        onChange={handleSelectChange}
                                        styles={selectStyles}
                                      />
                                    );
                                  })()
                                ) : currCategory?.datatype === "date" ? (
                                  <FilterDateInput
                                    value={
                                      Array.isArray(condition.userInput)
                                        ? condition.userInput
                                        : condition.userInput
                                          ? [condition.userInput]
                                          : []
                                    }
                                    placeholder={placeholder}
                                    error={
                                      !!conditionErrors.find(
                                        (error) => error.userInput
                                      )?.userInput
                                    }
                                    onChange={(values) => {
                                      handleConditionChange(
                                        conditionIndex,
                                        "userInput",
                                        values
                                      );
                                      userAction(true);
                                    }}
                                  />
                                ) : isMultiple === true ? (
                                  <InComponent
                                    handleConditionChange={
                                      handleConditionChange
                                    }
                                    inOperatorMaxValues={inOperatorMaxValues}
                                    userAction={(e) => userAction(true)}
                                    conditionIndex={conditionIndex}
                                    externalStyles={{
                                      border: "none",
                                      minHeight: "32px",
                                      borderTopRightRadius: "8px",
                                      borderBottomRightRadius: "8px",
                                    }}
                                    initialData={
                                      condition.userInput
                                        ? condition.userInput.map((row) => ({
                                            label: row,
                                            value: row,
                                          }))
                                        : []
                                    }
                                    placeHolder={placeholder}
                                    shoeError={
                                      conditionErrors.some(
                                        (error) => error.userInput
                                      ) && condition.userInput.length === 0
                                    }
                                    removeSelected={
                                      condition.userInput ? false : true
                                    }
                                    validate={currCategory?.datatype}
                                  />
                                ) : (
                                  <TextField
                                    fullWidth
                                    size="small"
                                    placeholder={placeholder}
                                    value={condition?.userInput}
                                    sx={{
                                      borderTop: "none",
                                      borderRight: "none",
                                      textWrap: "nowrap",
                                      fontSize: "12px",
                                    }}
                                    slotProps={{
                                      htmlInput: {
                                        sx: {
                                          border: "none",
                                          padding: "4px 8px",
                                          height: "auto",
                                          fontSize: "12px",
                                          "&::placeholder": {
                                            color: (theme) =>
                                              theme.palette.secondary.main, // 👈 placeholder color
                                            opacity: 1, // make sure it’s fully visible
                                          },
                                        },
                                      },
                                      input: {
                                        sx: {
                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderLeft: "none",
                                              borderTop: "none",
                                              borderRight: "none",
                                              borderBottom: "none",
                                            },
                                          "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderLeft: "none",
                                            },
                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderLeft: "none",
                                            },
                                          borderRadius: 0,
                                        },
                                        startAdornment: currency ? (
                                          <InputAdornment sx={{ p: 0 }}>
                                            {currency}
                                          </InputAdornment>
                                        ) : null,
                                      },
                                    }}
                                    error={
                                      !!conditionErrors.find(
                                        (error) => error.userInput
                                      )?.userInput
                                    }
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      if (
                                        validate(
                                          inputValue,
                                          currCategory?.datatype
                                        )
                                      ) {
                                        handleConditionChange(
                                          conditionIndex,
                                          "userInput",
                                          [inputValue]
                                        );
                                      }
                                      userAction(true);
                                    }}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        {
                          <span
                            className={styles?.errorText}
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                              color: "red",
                            }}
                          >
                            {conditionErrors.find((error) => error.userInput)
                              ?.userInput || ""}
                          </span>
                        }
                      </div>
                      <div
                        onClick={() => {
                          userAction(true);
                          removeCondition(conditionIndex);
                          if (conditions?.length === 1) {
                            removeGroupConditionContent();
                          }
                        }}
                        className={styles.select}
                        style={{
                          flexDirection: "column",
                          cursor: "pointer",
                          visibility: "visible",
                          paddingLeft: "8px",
                          marginBottom: "auto",
                          marginTop: "6px",
                        }}
                      >
                        <DeleteOutlineIcon
                          sx={{
                            fontSize: "20px",
                            color: "#6C6C6C",
                            cursor: "pointer",
                            transition: "color 0.2s ease",
                            "&:hover": {
                              color: "red",
                            },
                          }}
                        />
                      </div>
                    </div>
                    {helpText && (
                      <p
                        style={{
                          color: "#637381",
                          fontWeight: "400",
                          padding: "2px 32px 2px 2px",
                          fontSize: "12px",
                          textAlign: "right",
                        }}
                      >
                        *NOTE : {helpText}
                      </p>
                    )}
                  </>
                );
              })}
            </div>
          </div>
          <div style={{ display: "flex", padding: "4px 0px", gap: "8px" }}>
            {multiple && (
              <div className={styles.addCondition}>
                <div
                  onClick={(e) => {
                    addCondition();
                    userAction(true);
                  }}
                  className={styles.Condition}
                  style={{ cursor: "pointer" }}
                >
                  <Add fontSize="small"></Add>
                  <span className={styles.addText}>New Condition</span>
                </div>
              </div>
            )}
            {multiple && showGroupCondition && (
              <div className={styles.addCondition}>
                <div
                  onClick={(e) => {
                    groupConditionFunc();
                  }}
                  className={styles.Condition}
                  style={{ cursor: "pointer" }}
                >
                  <Add fontSize="small"></Add>
                  <span className={styles.addText}>New Group</span>
                </div>
              </div>
            )}
          </div>
          {showCloseButton && (
            <div
              className={styles.closeButton}
              onClick={(e) => {
                userAction(true);
                removeGroupConditionContent();
              }}
            >
              <HighlightOffIcon
                sx={{ color: "white", fontSize: 20, cursor: "pointer" }}
              />
            </div>
          )}
        </div>
      </div>
    );
};



export default ComplexFilters;

